import PropTypes from "prop-types"
import React from "react"
import TextChartODD13GHGEmissionsEmployeeMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsEmployeeMolecule"
import TextChartODD13MobileDataConsumptionEmployeeMolecule from "views/molecules/canvases/charts/TextChartODD13MobileDataConsumptionEmployeeMolecule"
import TextChartODD13AverageEquipmentsPerFteMolecule from "views/molecules/canvases/charts/TextChartODD13AverageEquipmentsPerFteMolecule"
import ChartODD13EquipmentTypeVolumeAverageGHGMolecule from "views/molecules/canvases/charts/ChartODD13EquipmentTypeVolumeAverageGHGMolecule"
import ChartODD13EquipmentVolumeEmissionsTopLocMolecule from "views/molecules/canvases/charts/ChartODD13EquipmentVolumeEmissionsTopLocMolecule"
import ChartODD13EquipmentFteTopEmissionsLocMolecule from "views/molecules/canvases/charts/ChartODD13EquipmentFteTopEmissionsLocMolecule"
import TextChartOdd13GhgEmissionTab from "views/molecules/canvases/charts/TextChartODD13GHGEmissionTab"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import { useTranslation } from "react-i18next"
import { useAppContext } from "components/AppContext"
import ScoreLayoutOrganism from "views/organisms/scores/ScoreLayoutOrganism"

const WorkplaceAnalysisOrganism = ({ score, isOnGlobalDashboard }) => {
  const { t } = useTranslation()
  const { score: globalScore } = useAppContext()

  const chart1TrendBadge = globalScore?.trend_badges?.odd13_workplace_CO2
  const chart2TrendBadge = globalScore?.trend_badges?.odd13_CO2_average_employee
  const chart5TrendBadge = globalScore?.trend_badges?.odd13_network_mobile_conso_per_employee
  const maturityTrendBadge = globalScore?.trend_badges?.odd13_workplace_maturity

  return (
    <ScoreLayoutOrganism
      maturity={score?.odd13_workplace_maturity ?? 0}
      maturityTrendBadge={maturityTrendBadge} 
      chart1={
        <TextChartOdd13GhgEmissionTab
          ghgEmissions={score?.odd13_workplace_CO2}
          ghgEmissionsCollect={score?.odd13_CO2}
          node={score?.node}
          hidePercentageOfEmissions={isOnGlobalDashboard}
          trendBadge={chart1TrendBadge}
        />
      }
      chart2={
        <TextChartODD13GHGEmissionsEmployeeMolecule 
          score={score} 
          trendBadge={chart2TrendBadge}
        />
      }
      chart3={
        <ChartODD13EquipmentVolumeEmissionsTopLocMolecule
          mixedChart={score?.odd13_co2_workplace_equipment_volume_ghg_top}
        />
      }
      chart4={
        <ChartODD13EquipmentTypeVolumeAverageGHGMolecule
          mixedChart={score?.odd13_workplace_equipment_type_average}
          type="workplace"
        />
      }
      chart5={(() => {
        const mobileData = score?.odd13_network_mobile_conso_per_employee || 0
        const hasMobileData = Number(mobileData) > 0

        if (!hasMobileData) {
          return <TextChartODD13AverageEquipmentsPerFteMolecule score={score} />
        }

        return (
          <HelpWidgetChartInteractiveMolecule
            text={t(
              `analyze:it_domain.consolidated.workplace.chartMobileDataConsumptionEmployee.help`
            )}
          >
            <TextChartODD13MobileDataConsumptionEmployeeMolecule 
              score={score} 
              trendBadge={chart5TrendBadge}
            />
          </HelpWidgetChartInteractiveMolecule>
        )
      })()}
      chart6={
        <ChartODD13EquipmentFteTopEmissionsLocMolecule
          mixedChart={score?.odd13_co2_equipment_emissions_top}
        />
      }
    />
  )
}

WorkplaceAnalysisOrganism.propTypes = {
  score: PropTypes.object.isRequired,
  isOnGlobalDashboard: PropTypes.bool,
  trendBadges: PropTypes.object, 
}

WorkplaceAnalysisOrganism.defaultProps = {
  isOnGlobalDashboard: false,
  trendBadges: {},
}

export default WorkplaceAnalysisOrganism